import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const GrazianosModal = (props) => {
  let msgInput = {marginTop: '5px', width: '100%'}
  const zIndex = props.zIndex ? props.zIndex : 1000;
  const autoFocus = props.autoFocus !== undefined ? props.autoFocus : true;
    return(
      <Modal isOpen={props.isModalOpen} toggle={props.closeModal} className={'modal-warning modal-logut'} zIndex={zIndex} autoFocus={autoFocus}>
        <ModalHeader toggle={props.closeModal}>{props.header}</ModalHeader>
        <ModalBody>
          <span>{props.content}</span>
          {props.textInput ? <textarea name="msg-input" style={msgInput} value={props.message} onChange={(msg) => {props.onMessageChange(msg)}}/> : ''}
          {props.children}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={props.onConfirm}>{props.onConfirmButtonText}</Button>{' '}
          <Button color="secondary" onClick={props.onCancel}>{props.onCancelButtonText}</Button>
        </ModalFooter>
      </Modal>
    )
}
export default GrazianosModal
